<div #step4 class="ui-g">

  <div class="ui-g-12 ui-lg-4 campaign-card-pad">
    <div class="card left">
      <div class="ui-g form-group">
        <div class="ui-g-12">
          <h1 class="campaign-step">{{ 'campaign.defineTarget' | translate }}</h1>
        </div>
        <div class="ui-g-12">
          <button pButton type="button" class="ButtonCampaign" label="{{'common.stores' | translate}}" [ngClass]="{ 'active': panel == 1 }" (click)="setPanel(1)"></button>
        </div>
        <div class="ui-g-12">
          <button pButton type="button" class="ButtonCampaign" label="{{'campaign.customers' | translate}}" [ngClass]="{ 'active': panel == 2 }" (click)="setPanel(2)"></button>
        </div>
        <div class="ui-g-12">
          <button pButton type="button" class="ButtonCampaign" label="Coupon" [ngClass]="{ 'active': panel == 3 }" (click)="setPanel(3)"></button>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 ui-lg-8 campaign-card-pad">
    <campaign-stores
    *ngIf="panel == 1"
    [campaign]="campaign"
    [savedCategories]="savedCategories"
    [targetedStores]="targetedStores"
    [savedProductCouponsF]="savedProductCouponsF"
    [savedProductCouponsNF]="savedProductCouponsNF"
    [returnedSavedCategories]="returnedSavedCategories"
    [returnedSavedProductCouponsF]="returnedSavedProductCouponsF"
    [returnedSavedProductCouponsNF]="returnedSavedProductCouponsNF"
    (returnedSavedCategoriesEmitter)="returnSavedCategories($event)"
    (returnedSavedProductCouponsFemitter)="returnSavedProductCouponsF($event)"
    (returnedSavedProductCouponsNFemitter)="returnSavedProductCouponsNF($event)"
    (newTargetedStores)="updateTargetedStores($event)"></campaign-stores>
    <campaign-segments
    *ngIf="panel == 2"
    [campaign]="campaign"
    [savedCategories]="savedCategories"
    [savedProductCouponsF]="savedProductCouponsF"
    [savedProductCouponsNF]="savedProductCouponsNF"
    [returnedSavedCategories]="returnedSavedCategories"
    [returnedSavedProductCouponsF]="returnedSavedProductCouponsF"
    [returnedSavedProductCouponsNF]="returnedSavedProductCouponsNF"
    (returnedSavedCategoriesEmitter)="returnSavedCategories($event)"
    (returnedSavedProductCouponsFemitter)="returnSavedProductCouponsF($event)"
    (returnedSavedProductCouponsNFemitter)="returnSavedProductCouponsNF($event)"></campaign-segments>
    <campaign-coupons
    #campaignCoupons
    *ngIf="panel == 3"
    [campaign]="campaign"
    (savedSelectedCategories)="saveSelectedCategories($event)"
    (savedProductCouponsF)="saveSelectedProductCouponsF($event)"
    (savedProductCouponsNF)="saveSelectedProductCouponsNF($event)"
    [returnedSavedCategories]="returnedSavedCategories"
    [returnedSavedProductCouponsF]="returnedSavedProductCouponsF"
    [returnedSavedProductCouponsNF]="returnedSavedProductCouponsNF"
    ></campaign-coupons>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/campaign-step-4.html